import { render, staticRenderFns } from "./Bolo.vue?vue&type=template&id=6a9d820c&scoped=true&"
import script from "./Bolo.vue?vue&type=script&lang=js&"
export * from "./Bolo.vue?vue&type=script&lang=js&"
import style0 from "./Bolo.vue?vue&type=style&index=0&id=6a9d820c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9d820c",
  null
  
)

export default component.exports